<template lang="pug">
    main
      NavBar
      Loader(v-show="isLoading")
      section.section(v-show="!isLoading")
        .container
          .columns
            .column.is-half.is-offset-one-quarter.has-text-centered
              h3.title(style='margin-bottom: 8px') GESTIÓN DE GRUPOS TPA
            br
          .columns
            .column.is-3
              b.has-text-black(@click="backPage")
                a.button.is-light.is-rounded
                  span.icon
                    i.fas.fa-angle-left
                  | &nbspRegresar
            .column.is-offset-7.is-0
              b.has-text-black(@click="showFormGrupos = !showFormGrupos")
                a.button.is-light.is-rounded
                  | &nbspNuevo grupo
            br
          .columns(v-show="showFormGrupos")
            .column.is-12
              .columns.is-12
                .column.is-8.is-half.is-offset-one-quarter.has-text-centered
                  .column.is-8
                    .field
                      .control
                        input.input.is-primary(
                          type='text', 
                          id='nombreNuevoGrupo'
                          placeholder='Escribe el nombre de nuevo grupo',
                        )
                    .column.is-9.has-text-centered
                      label Selecciona una compañia
                        .select.is-primary.is-rounded(style="margin-left:10px;")
                          select(v-model="CompaniaSel" :disabled="isDisabled" style="width:200px;" id="idCompaniaSelected" )
                            option(v-for="data in Companias" :value="data.id" :key="data.id") {{ data.Compania }}
                    
                    b.has-text-black(@click="guardarNuevoGrupo")
                      a.button.is-light.is-rounded(
                        style="margin-right:8px;"
                      )
                        | Guardar
                    b.has-text-black(@click="showFormGrupos = false")
                      a.button.is-light.is-rounded
                        | Cancelar
          .column
            .column.is-12
              ContainerGruposSubgrupos(:Comp="Comp")
  </template>
  
  <script>
    import Loader from '@/components/shared/Loader.vue'
    import NavBar from './layout/NavBar.vue'
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'
    import ContainerGruposSubgrupos from './componentes/ContainerGruposSubgrupo.vue'
    import grupos_tpaServices from '@/services/sca/grupos/gruposTPA.js'
  
    export default {
      name: 'gestionGrupos',
      components: { Loader, NavBar, flatPickr, ContainerGruposSubgrupos },
      data() {
        return {
          isLoading: false,
          showFormGrupos: false,
          isDisabled: false,
          Comp:[],
          Companias:[],
          CompaniaSel:{},
        }

      },
      watch: {  },
      methods: {
        
        iniciarComponente () {
          this.isLoading = false
          this.obtenerCompania()
          this.obtenerGrupos()
        },
  
        backPage() {
          this.$router.back()
        },

        obtenerCompania () {
          grupos_tpaServices.obtenerCompanias()
            .then( data => {
              this.Companias = data
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
            })
        },

        obtenerGrupos () {
          grupos_tpaServices.obtenerGrupos()
            .then( data => {
              this.Comp = data
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
            })
        },

        displayToast(tema, text, icon, actionText) {
          let toast = this.$toasted.show(text, { 
            theme: tema, 
            position: "bottom-right", 
            duration : 2000,
            iconPack: 'fontawesome',
            icon: icon,
            action : {
              text : actionText,
              onClick : (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          })
        },

        guardarNuevoGrupo(){
          if(nombreNuevoGrupo.value && idCompaniaSelected.value){
            grupos_tpaServices.guardarNuevoGrupo( nombreNuevoGrupo.value, idCompaniaSelected.value)
              .then( resp => {
                if (resp.success) {
                  nombreNuevoGrupo.value = ''
                  idCompaniaSelected.value = 0
                  this.showFormGrupos = false
                  this.obtenerGrupos()

                  let toast = this.$toasted.show(`El grupo se ha registrado correctamente.`, { 
                    theme: "toasted-primary", 
                    position: "bottom-right", 
                    duration : 3000,
                    iconPack: 'fontawesome',
                    icon: 'ban',
                    action : {
                      text : 'Ok',
                      onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                  })
                } else {
                  let toast = this.$toasted.show(`Error: ${resp.respuesta}`, { 
                    theme: "toasted-primary", 
                    position: "bottom-right", 
                    duration : 3000,
                    iconPack: 'fontawesome',
                    icon: 'ban',
                    action : {
                      text : 'Ok',
                      onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                  })
                }
              })
              .catch(e => console.log(e))
          } else{
            let toast = this.$toasted.show(`Falta información por obtener.`, { 
              theme: "toasted-primary", 
              position: "bottom-right", 
              duration : 3000,
              iconPack: 'fontawesome',
              icon: 'ban',
              action : {
                text : 'Ok',
                onClick : (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
            })
          }  
        },

        eventLoading (val) {
          this.isLoading = val
        }, 
      },
      created () {
        this.iniciarComponente()
      },
    }
  </script>
  
  <style lang="scss" scoped>
    .column-blanco {
      padding-bottom: 100px;
    }
    .label-radio {
      margin-right: 10px;
    }
    .is-radio-input {
      padding-right: 5px;
    }
  </style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/cuartocontrol/gestionGrupos.vue